// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import Axios from 'axios'
import Md5 from 'js-md5';
import Api from "./request/api"
import CommonFun from "./assets/js/commonFun"
import { Spinner } from "mint-ui";



Vue.config.productionTip = false
Vue.prototype.$Axios = Axios
Vue.prototype.$Api = Api;
Vue.prototype.$CommonFun = CommonFun;
Vue.prototype.$Md5 = Md5;
Vue.use(Mint);
Vue.component(Spinner.name, Spinner);



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js